import { useCallback, useState } from "react";

const useExpandedRowIds = () => {
  const [expandedIds, setExpandedIds] = useState(() => new Set());

  const toggleExpand = useCallback((row) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(row.id)) next.delete(row.id);
      else next.add(row.id);
      return next;
    });
  }, []);

  const expandAll = useCallback((expandableIds) => {
    setExpandedIds(new Set(expandableIds));
  }, []);

  const collapseAll = useCallback(() => {
    setExpandedIds(new Set());
  }, []);

  const resetExpanded = useCallback(() => setExpandedIds(new Set()), []);

  return { expandedIds, toggleExpand, expandAll, collapseAll, resetExpanded };
};

export default useExpandedRowIds;
